import AppTheme from '@libs/mui/AppTheme';
import { Stack, Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ProcedureType } from '../entity';

type ProcedureCardHeaderProps = {
  isPreviousCopy: boolean;
  orderNumber: number;
  cardType?: ProcedureType;
};

const ProcedureCardHeader = ({
  isPreviousCopy,
  orderNumber,
  cardType,
}: ProcedureCardHeaderProps) => (
  <Stack sx={{ borderRadius: 0, padding: '1rem' }} spacing={1}>
    <Box
      sx={{
        borderRight: {
          xs: 'none',
          sm: `2px dotted ${AppTheme.palette.primary.light}`,
          paddingRight: '12px',
        },
        borderBottom: { xs: `2px dotted ${AppTheme.palette.primary.light}`, sm: 'none' },
        textWrap: 'wrap',
        pb: { xs: 1, sm: 0 },
      }}
    >
      {isPreviousCopy ? (
        <Typography variant="body2" fontWeight={600} color="success.dark">
          <FormattedMessage id="procedureCard.consumption" defaultMessage="Poslední spotřeba" />
        </Typography>
      ) : cardType === 'SALE' ? (
        <Typography variant="body2" fontWeight={600} color="info.dark">
          <FormattedMessage id="procedureCard.sale" />
        </Typography>
      ) : (
        <Typography variant="h6" sx={{ padding: 1 }} color="primary">
          <FormattedMessage id="procedureCard.procedure" />
        </Typography>
      )}
    </Box>
  </Stack>
);
export default ProcedureCardHeader;
